import * as React from 'react';
import {CardProps} from '.';

const CardContext
  = React.createContext<Partial<CardProps>>({});

export default CardContext;
